import { select } from 'redux-saga/effects';
import {
  businessCategorySelector,
  customStepsSelector,
  shouldUseDesktopPagesSelector,
  showCaseCreationPageSelector,
  showCasePageSelector,
  showContactPageSelector,
  showIntroSelector,
} from 'redux/selectors/config';
import { routesConfig } from 'Routes/routesConfig';
import { getCurrentPath } from 'hooks/routes-hooks';

export const notTrackedPages = [
  'intro',
  'notification',
  'upload-pictures',
  'case',
  'vehicle-details',
  'location-details-map',
];
export const createStepMap = (array, step) =>
  array
    .map((p, index) => {
      if (typeof p === 'string') {
        return { [p]: step >= 0 ? { step, subStep: index } : { step: index } };
      } else {
        return createStepMap(p, index);
      }
    })
    .reduce((acc, current) => ({ ...acc, ...current }), {});

export const getNextStep = (orders, nextPage) =>
  createStepMap(orders)[nextPage];

export function* getCurrentRoute() {
  const businessCategory = yield select(businessCategorySelector);
  const customCaseCreationSteps = yield select(customStepsSelector);
  const showCaseCreationPage = yield select(showCaseCreationPageSelector);
  const showCasePage = yield select(showCasePageSelector);
  const showContactPage = yield select(showContactPageSelector);
  const showIntro = yield select(showIntroSelector);
  const shouldUseDesktopPages = yield select(shouldUseDesktopPagesSelector);

  const currentRoutes = routesConfig({
    businessCategory,
    customCaseCreationSteps,
    shouldUseDesktopPages,
    showCaseCreationPage,
    showCasePage,
    showContactPage,
    showIntro,
  });
  const currentRoute = getCurrentPath(currentRoutes.map(({ path }) => path));
  const pageName = currentRoutes.find(
    ({ path }) => path === currentRoute?.path,
  )?.name;

  return { currentRoute, pageName };
}
